var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#CADDE8",
    d: "M31.947 39.898c3.563 3.285 7.032 6.672 10.407 10.153M2.348 33.635c9.553 1.462 19.047 3.273 28.471 5.425.302.067.674.432.408.596",
    transform: "translate(23.52 25.76)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7FC689",
    d: "M32.259 37.922c-.627.044-1.278.094-1.811.455-.53.365-.796 1.11-.584 1.748.368 1.098 2.38 1.772 4.39.941.913-.376 1.204-1.293 1.011-1.932-.105-.337-.403-.56-.701-.722-.808-.43-1.74-.584-2.63-.43",
    transform: "translate(23.52 25.76)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CADDE8",
    d: "M41.565 26.775L41.565 57.614",
    transform: "translate(23.52 25.76)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FCEDAE",
    d: "M27.554 1.697c-4.884 2.172-7.856 7.961-6.778 13.195.745 3.606 3.101 6.632 5.285 9.596 2.642 3.587 5.127 7.295 7.444 11.101M32.785 1.613c3.172.497 5.731 2.842 7.734 5.347.694.874 1.353 1.787 1.796 2.81 1.05 2.423.792 5.175.94 7.809M28.567 24.512c.023.028.047.051.074.075M31.926 29.768c-.012.079.067.153.145.142M33.603 24.803L33.603 24.882",
    transform: "translate(23.52 25.76)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CADDE8",
    d: "M42.237 49.575c1.372-2.014 2.87-3.935 4.367-5.852 5.456-6.993 10.913-13.99 16.37-20.988M51.614 37.946c4.182 4.265 7.318 7.028 12.258 12.355M13.513 22.193c.588 4.57 1.109 8.64 1.7 13.21",
    transform: "translate(23.52 25.76)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#324580",
    d: "M43.175 59.88c.165-3.95.102-6.51.063-10.368-.032-3.05.047-4.84.098-7.926.035-2.462-.024-11.011-.145-15.108M63.874 50.303c.015-4.599.29-7.754.047-12.223-.224-4.104.274-14.869-.326-21.043M43.175 59.88c2.47-1.14 3.583-1.677 5.453-2.536.842-.392 1.685-.764 2.528-1.136 1.772-.792 9.925-4.465 12.716-5.904M43.431 26.369L63.596 17.036",
    transform: "translate(23.52 25.76)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#324580",
    d: "M43.431 26.37c-.02 4.601.232 7.753-.047 12.222-.259 4.104.157 14.869-.49 21.039M22.803 50.172L43.176 59.882M22.744 24.497c.032 3.05-.05 7.374-.098 10.455-.039 2.462.024 11.015.145 15.108M2.109 26.235c-.016 4.602-.294 7.754-.047 12.223.223 4.108-.279 14.868.325 21.042M19.98 17.978c-2.47 1.144-.756.36-2.626 1.223-.843.384-1.686.76-2.529 1.133-1.771.788-9.925 4.46-12.716 5.9M22.551 50.172L2.386 59.502",
    transform: "translate(23.52 25.76)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F3D139",
    d: "M21.146 20.995c-1.09-2.203-1.72-4.638-1.85-7.1-.063-1.199-.008-2.414.25-3.594.977-4.434 4.438-7.436 8.75-8.86 1.69-.556 5.225-1.222 8.989.53 3.147 1.466 5.633 4.355 6.393 7.742.85 3.798-.337 7.734-1.63 11.403-1.059 3.003-2.207 5.986-3.799 8.742-.874 1.513-3.834 8.636-6.088 7.656-.698-.306-9.968-14.395-11.015-16.52z",
    transform: "translate(23.52 25.76)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F3D139",
    d: "M28.012 15.023c.172 1.062.944 1.967 1.889 2.477.945.51 2.101.62 3.124.298 1.027-.322 1.933-1.058 2.4-2.03 1.68-3.513-.62-6.167-3.125-6.167-2.626 0-4.83 2.12-4.288 5.422z",
    transform: "translate(23.52 25.76)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.4a8b7d804031398170ec375b1661fe37.svg";
export { ForwardRef as ReactComponent };